import { useStore as useInternalStore } from '@mui/x-internals/store';

export const useSelector = useInternalStore;
